export const isValidDob = (dob: string, currentDate: Date = new Date()): boolean => {
  const dobDate = new Date(dob)
  if (dobDate > currentDate) {
    return false
  }

  if (dobDate.getFullYear() < 1907) {
    return false
  }

  return true
}

const isBirthdayThisYear = (dobDate: Date, today: Date): boolean => {
  const monthDiff = today.getMonth() - dobDate.getMonth()
  const dayDiff = today.getDate() - dobDate.getDate()

  return monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)
}

const isAgeOver =
  (checkAge: number) =>
  (dob: string, currentDate: Date = new Date()): boolean => {
    const dobDate = new Date(dob)
    const age = currentDate.getFullYear() - dobDate.getFullYear()

    if (isBirthdayThisYear(dobDate, currentDate)) {
      return age - 1 >= checkAge
    }

    return currentDate.getFullYear() - dobDate.getFullYear() >= checkAge
  }

export const isOver18YearsOld = isAgeOver(18)
export const isOver16YearsOld = isAgeOver(16)
